import { combineReducers, Reducer } from 'redux';
import { Action } from '../actions';
import { GenericState, initialGenericState } from '../reduxTypes';
import { FLUSH_RESULTS } from './ApiManagementProductionReducer/ApiManagementProductionReducers';

export interface IAddCertState extends GenericState { }

export const initialAddCertState = initialGenericState

export const ADD_CERTIFICATE = 'ADD_CERTIFICATE';
export const ADD_CERTIFICATE_ERROR = 'ADD_CERTIFICATE_ERROR';

function addCerticateReducer(state = initialAddCertState, action: Action) {
    switch (action.type) {
        case `${ADD_CERTIFICATE}_PENDING`:
            return { ...state, data: null, loading: true, error: false }
        case `${ADD_CERTIFICATE}_FULFILLED`:
            return { ...state, data: action.payload, loading: false, error: false }
        case `${ADD_CERTIFICATE}_REJECTED`:
            return { ...state, loading: false }
        case ADD_CERTIFICATE_ERROR:
            return { ...state, error: true, data: action.payload }
        case FLUSH_RESULTS:
            return initialAddCertState
        default: return state
    }
}

export interface IDeleteCertState extends GenericState { }

export const initialDeleteCertState = initialGenericState

export const DELETE_CERTIFICATE = 'DELETE_CERTIFICATE';
export const DELETE_CERTIFICATE_ERROR = 'DELETE_CERTIFICATE_ERROR';

function deleteCertificateReducer(state = initialDeleteCertState, action: Action) {
    switch (action.type) {
        case `${DELETE_CERTIFICATE}_PENDING`:
            return { ...state, data: null, loading: true, error: false }
        case `${DELETE_CERTIFICATE}_FULFILLED`:
            return { ...state, data: { ...action.payload, result: 'Deleted' }, loading: false, error: false }
        case `${DELETE_CERTIFICATE}_REJECTED`:
            return { ...state, loading: false }
        case DELETE_CERTIFICATE_ERROR:
            return { ...state, data: action.payload, error: true }
        case FLUSH_RESULTS:
            return initialDeleteCertState
        default: return state
    }
}

export interface ICertificateState {
    addCertificateResult: IAddCertState,
    deleteCertificateResult: IDeleteCertState
}
export const certificateReducer: Reducer<ICertificateState> = combineReducers({
    addCertificateResult: addCerticateReducer,
    deleteCertificateResult: deleteCertificateReducer
})